import { render, staticRenderFns } from "./SelectorSearch.vue?vue&type=template&id=23a5628e&scoped=true&"
import script from "./SelectorSearch.vue?vue&type=script&lang=js&"
export * from "./SelectorSearch.vue?vue&type=script&lang=js&"
import style0 from "./SelectorSearch.vue?vue&type=style&index=0&id=23a5628e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5628e",
  null
  
)

export default component.exports